/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Link from 'next/link';
import Card from '@avila-tek/ui/src/card/Card';
import { useQuery } from '@apollo/client';
import { formatCurrency } from '@avila-tek/ui/src';
import { Benefit, Company } from '../../../models';
import { GET_BENEFIT } from '../../../graphql/queries';
import { useUser } from '../../../hooks';
import fallbackImg from '../../../public/images/product-card-fallback.png';

function PointCard() {
  const [benefit, setBenefit] = React.useState<Benefit | null>(null);
  const [user] = useUser();

  const { data: dataGetBenefit } = useQuery<{
    benefit: Benefit;
  }>(GET_BENEFIT, {
    variables: {
      filter: {
        company: (user.company as Company)._id,
      },
    },
  });

  React.useEffect(() => {
    // We store the benefit in the state
    if (dataGetBenefit) {
      setBenefit(dataGetBenefit.benefit);
    }
  }, [dataGetBenefit]);
  return (
    <Card className="ml-5">
      <Link
        href={`/app/catalogue/points?benefitId=${benefit?._id}&benefitValue=${benefit?.value}`}
      >
        <div className="bg-system-100 rounded-lg w-48  drop-shadow hover:shadow-lg transition-all duration-500">
          <div className="h-full w-full font-title font-medium lg:text-sm text-xs  text-black">
            <div className="flex flex-col rounded-lg space-y-3 justify-around pb-2">
              <div className="h-32">
                <img
                  src={fallbackImg.src}
                  alt="product"
                  className="rounded-tr-lg rounded-tl-lg object-fill w-full h-full"
                />
              </div>
              <div className="flex flex-col px-4  justify-center">
                <span className="text-neutral-cold-800  font-semibold  ">
                  Puntos prepagados
                </span>
              </div>
              <div className="w-full flex mx-auto gap-2 items-center px-4 ">
                <span className="text-purple-300 text-lg font-extrabold">
                  ${formatCurrency(benefit?.value ?? 0)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </Card>
  );
}

export default PointCard;
